import { render, staticRenderFns } from "./WorkflowStepDetails.vue?vue&type=template&id=64721e19&scoped=true&"
import script from "./WorkflowStepDetails.vue?vue&type=script&lang=js&"
export * from "./WorkflowStepDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowStepDetails.vue?vue&type=style&index=0&id=64721e19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64721e19",
  null
  
)

export default component.exports